import * as THREE from 'three'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { TAARenderPass } from 'three/examples/jsm/postprocessing/TAARenderPass.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js'
// import { SMAAShader } from 'three/examples/jsm/shaders/SMAAShader.js'
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js'
import { GlitchPass } from 'three/examples/jsm/postprocessing/GlitchPass.js'
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader'
import { ComicalConvertionShader } from '@/shader/comicalConvertion'
import { ToneShader } from '@/shader/Tone'
import { SelectiveCustomOutlinePass } from '@/shader/SelectiveCustomOutlinePass'
import { CustomOutlinePass } from '@/shader/CustomOutlinePassV2'
import FindSurfaces from '@/shader/FindSurfaces.js'
import { RGBAFormat, sRGBEncoding } from 'three'
import { VRMUtils } from '@pixiv/three-vrm'

export default {
  data () {
    return {
      size: {},
      defaultCameraFov: 35,
      defaultCameraNearFar: [0.1, 128],
      defaultAmbientLightIntensity: 0.0,
      // defaultAmbientLightIntensity: 0.5,
      defaultDirectionalLightIntensity: 1.0,
      defaultComicalShaderThreholdValue: [0.40000, 0.77059],
      initialSize3dStage: 10.0,
      initialSize3dObject: 0.4,
      // for composer
      composer: null, renderPass: null, webGLRendererTarget: null,
      comicalConvertPass: null,
      effectFXAA: null, effectSMAA: null,
      selectiveCustomOutline: null, surfaceFinder: null,
      tonePass: null,
      tonePassIndex: 1
    }
  },
  methods: {
    createRenderer ({ size }) {
      this.size = size
      let renderer = new THREE.WebGLRenderer({
        // FXAAShaderの方が負荷が低いらしい
        // ---
        antialias: true,
        alpha: true,
        // ---
        // powerPreference: 'high-performance',
        // logarithmicDepthBuffer: true,
        preserveDrawingBuffer: true
      })
      renderer.outputEncoding = THREE.sRGBEncoding

      // for renderWithLayers
      renderer.autoClear = false
      renderer.setPixelRatio(window.devicePixelRatio)
      renderer.setSize(size.width, size.height)
      
      // renderer.gammaInput = true
      // renderer.gammaOutput = true
      // renderer.physicallyCorrectLights = true

      // renderer.outputEncoding = THREE.sRGBEncoding
      return renderer
    },
    // initializeComposer ({ renderer, scene, camera, comicalShaderThrehold=[0.77059, 0.40000] }) {
    initializeComposer ({ renderer, scene, camera, 
      comicalShaderThrehold={ x: 0.77059, y: 0.40000 }
    }) {
      const canvas = document.createElement('canvas')
      if (canvas.getContext('webgl2')) {
        const depthTexture = new THREE.DepthTexture()

        // example: https://jsfiddle.net/8brm24vw/1/
        this.webGLRendererTarget = new THREE.WebGLMultisampleRenderTarget(
          this.size.width, this.size.height,
          { 
            format: RGBAFormat,
            encoding: sRGBEncoding,
            // depthTexture: depthTexture,
            // depthBuffer: true
          }
        )
        this.webGLRendererTarget.samples = 4
        this.composer = new EffectComposer(renderer, this.webGLRendererTarget)

        // this.webGLRendererTarget = new THREE.WebGLRenderTarget( 
        //   this.size.width, this.size.height,
        //   {
        //     format: THREE.RGBAFormat,
        //     encoding: THREE.sRGBEncoding,
        //     samples: 4,
        //     // -----
        //     // minFilter: THREE.LinearFilter,
        //     // magFilter: THREE.LinearFilter,
        //     // type: THREE.HalfFloatType,
        //     // stencilBuffer: false,
        //   }
        // )
        // this.composer = new EffectComposer(renderer, this.webGLRendererTarget)
      } else {
        this.composer = new EffectComposer(renderer)
      }

      // this.composer = new EffectComposer(renderer)
      
      const pixelRatio = renderer.getPixelRatio()
      this.composer.setPixelRatio(devicePixelRatio)

      this.renderPass = new RenderPass(scene, camera)
      // // this.renderPass.clearColor = new THREE.Color(0, 0, 0)
			// // this.renderPass.clearAlpha = 0
      
      // this.renderPass = new TAARenderPass(scene, camera)
      // this.renderPass.unbiased = true
      // this.renderPass.sampleLevel = 4

      // 諧調変換 + 線画抽出
      // this.comicalConvertPass = new ShaderPass(ComicalConvertionShader)
      // this.comicalConvertPass.uniforms['resolution'].value.x = this.size.width * devicePixelRatio
      // this.comicalConvertPass.uniforms['resolution'].value.y = this.size.height * devicePixelRatio
      // this.comicalConvertPass.uniforms['threholdColorLimit'].value.x = comicalShaderThrehold.x
      // this.comicalConvertPass.uniforms['threholdColorLimit'].value.y = comicalShaderThrehold.y
      // // this.comicalConvertPass.uniforms['threholdColorLimit'].value.x = comicalShaderThrehold[0]// 0.77059
      // // this.comicalConvertPass.uniforms['threholdColorLimit'].value.y = comicalShaderThrehold[1] // 0.40000

      // 諧調変換
      const thresholdShaderParams = {
        uniforms: ToneShader.uniforms,
        vertexShader: ToneShader.vertex,
        fragmentShader: ToneShader.fragment
      }
      console.log('comicalShaderThrehold:', comicalShaderThrehold)
      thresholdShaderParams.uniforms['threholdColorLimit'].value.x = comicalShaderThrehold.x
      thresholdShaderParams.uniforms['threholdColorLimit'].value.y = comicalShaderThrehold.y
      this.tonePass = new ShaderPass(thresholdShaderParams)
      this.tonePass.renderToScreen = true
      this.tonePass.isTonePass = true
      
      this.selectiveCustomOutline = new SelectiveCustomOutlinePass(
        new THREE.Vector2(
          this.size.width,
          this.size.height
          // window.innerWidth * devicePixelRatio,
          // window.innerHeight * devicePixelRatio
        ),
        scene,
        camera
      )

      // CustomOutlineV2用
      // this.selectiveCustomOutline = new CustomOutlinePass(
      //   new THREE.Vector2(
      //     this.size.width,
      //     this.size.height
      //     // window.innerWidth * devicePixelRatio,
      //     // window.innerHeight * devicePixelRatio
      //   ),
      //   scene,
      //   camera
      // )
      // this.surfaceFinder = new FindSurfaces()

      this.effectFXAA = new ShaderPass(FXAAShader)
      // this.effectFXAA.material.uniforms['resolution'].value.x = 1 / (this.size.width * pixelRatio)
			// this.effectFXAA.material.uniforms['resolution'].value.y = 1 / (this.size.height * pixelRatio)
      this.effectFXAA.uniforms['resolution'].value.set(
        1 / window.innerWidth,
        1 / window.innerHeight
      )
      // this.effectFXAA.uniform = {
      //   resolution: {
      //     type: 'v2',
      //     value: {
      //       x: 1 / (window.innerWidth * pixelRatio),
      //       y: 1 / (window.innerHeight * pixelRatio)
      //     }
      //   }
      // }
      // this.effectFXAA.renderToScreen = false
      
      // this.effectFXAA.uniforms['resolution'].value.set(
      //   1 / (window.innerWidth * devicePixelRatio),
      //   1 / (window.innerHeight * devicePixelRatio)
      //   // 1 / window.innerWidth,
      //   // 1 / window.innerHeight
      // )

      this.effectSMAA = new SMAAPass(this.size.width * pixelRatio, this.size.height * pixelRatio)
      // this.effectSMAA = new ShaderPass(SMAAShader)
      // this.effectSMAA.material.uniforms['resolution'].value.x = 1 / (this.size.width * pixelRatio)
			// this.effectSMAA.material.uniforms['resolution'].value.y = 1 / (this.size.height * pixelRatio)

      this.composer.addPass(this.renderPass)
      // これをいれないとthree^0.143.0ではsRGBEncodingが効かない
      // この方法だと少し色合いが変わってしまってあまりきれいな発色にならないので一旦ヴァージョンを維持
      // const gammaCorrectionPass = new ShaderPass(GammaCorrectionShader)
      // this.composer.addPass(gammaCorrectionPass)

      // /*
      // // this.composer.addPass(this.effectFXAA)
      // // this.composer.addPass(this.comicalConvertPass)
      // */
      
      // 当座はこの二つでマンガ作画を表現中
      this.composer.addPass(this.tonePass)
      // 処理重いので開発中は切ってる
      // this.composer.addPass(this.selectiveCustomOutline)

      // // antialias: trueのほうがジャギつかない
      // this.composer.addPass(this.effectFXAA)
      // this.composer.addPass(this.effectSMAA)

      // for test
      // const glitchPass = new GlitchPass()
      // this.composer.addPass(glitchPass)
    },
    // for CustomOutlinePassV2
    addSurfaceIdAttributeToMesh (scene) {
      this.surfaceFinder.surfaceId = 0

      scene.traverse((node) => {
        if (node.type == 'Mesh') {
          const colorsTypedArray = this.surfaceFinder.getSurfaceIdAttribute(node)
          node.geometry.setAttribute(
            'color',
            new THREE.BufferAttribute(colorsTypedArray, 4)
          )
        }
      })

      this.selectiveCustomOutline.updateMaxSurfaceId(this.surfaceFinder.surfaceId + 1)
    },
    addTonePass () {
      const existingTonePass = this.composer.passes
        .filter(pass => pass.isTonePass)[0]
      if (!existingTonePass) this.composer.insertPass(this.tonePass, this.tonePassIndex)
    },
    removeTonePass () {
      this.composer.removePass(this.tonePass)
    },
    renderWithLayers ({ renderer, scene, camera }) {
      // renderer.clear()
      // renderer.render(scene, camera)
      // return

      renderer.clear()
      camera.layers.set(0)
      this.composer.render(scene, camera)

      renderer.clearDepth()
      camera.layers.set(1)
      renderer.render(scene, camera)
    },
    resizeComposer ({ canvasSize, renderer }) {
      const canvas = document.createElement('canvas')
      if (!canvas.getContext('webgl2')) {
        // webgl2でcomposerをリサイズするとバグる
        this.composer.setSize(canvasSize.width, canvasSize.height)
      }

      const pixelRatio = this.renderer.getPixelRatio()

      this.tonePass.setSize(canvasSize.width, canvasSize.height)
      // そのままsetSizeすると解像度が落ちるので再度初期化する
      // this.selectiveCustomOutline.setSize(canvasSize.width, canvasSize.height)
      this.selectiveCustomOutline = new SelectiveCustomOutlinePass(
        new THREE.Vector2(window.innerWidth, window.innerHeight),
        this.selectiveCustomOutline.renderScene,
        this.selectiveCustomOutline.renderCamera
      )
      
      this.effectFXAA.material.uniforms['resolution'].value.x = 1 / (this.size.width * pixelRatio)
			this.effectFXAA.material.uniforms['resolution'].value.y = 1 / (this.size.height * pixelRatio)
      // this.effectFXAA.setSize(canvasSize.width, canvasSize.height)

      if (this.webGLRendererTarget) {
        this.webGLRendererTarget.width = canvasSize.width
        this.webGLRendererTarget.height = canvasSize.height
      }
    },
    // updateComicalConvertPassThrehold (comicalShaderThrehold=[0.77059, 0.40000]) {
    //   console.log('comicalShaderThrehold:', comicalShaderThrehold)
    //   if (!this.comicalConvertPass) return
    //   // this.comicalConvertPass.uniforms['threholdColorLimit'].value.x = comicalShaderThrehold[0]// 0.77059
    //   // this.comicalConvertPass.uniforms['threholdColorLimit'].value.y = comicalShaderThrehold[1] // 0.40000
    //   this.comicalConvertPass.uniforms['threholdColorLimit'].value.x = 0.77059
    //   this.comicalConvertPass.uniforms['threholdColorLimit'].value.y = 0.40000
    // },
    updateComicalConvertPassThrehold (comicalShaderThrehold={ x: 0.77059, y: 0.40000 }) {
      // console.log('comicalShaderThrehold:', comicalShaderThrehold)

      if (!this.tonePass) return
      this.tonePass.uniforms['threholdColorLimit'].value.x = comicalShaderThrehold.x
      this.tonePass.uniforms['threholdColorLimit'].value.y = comicalShaderThrehold.y
      
      // if (!this.comicalConvertPass) return
      // // this.comicalConvertPass.uniforms['threholdColorLimit'].value.x = comicalShaderThrehold[0]// 0.77059
      // // this.comicalConvertPass.uniforms['threholdColorLimit'].value.y = comicalShaderThrehold[1] // 0.40000
      // this.comicalConvertPass.uniforms['threholdColorLimit'].value.x = comicalShaderThrehold.x
      // this.comicalConvertPass.uniforms['threholdColorLimit'].value.y = comicalShaderThrehold.y
    },
    disposeNode (node) {
      const clearMaterial = (mtrl) => {
        if (mtrl.map) {
          if (mtrl.map.image && mtrl.map.image.close) {
            // console.log('close')
            mtrl.map.image.close()
          }
        }
        if (mtrl.map)               mtrl.map.dispose()
        if (mtrl.lightMap)          mtrl.lightMap.dispose()
        if (mtrl.bumpMap)           mtrl.bumpMap.dispose()
        if (mtrl.normalMap)         mtrl.normalMap.dispose()
        if (mtrl.specularMap)       mtrl.specularMap.dispose()
        if (mtrl.envMap)            mtrl.envMap.dispose()
        if (mtrl.alphaMap)          mtrl.alphaMap.dispose()
        if (mtrl.aoMap)             mtrl.aoMap.dispose()
        if (mtrl.displacementMap)   mtrl.displacementMap.dispose()
        if (mtrl.emissiveMap)       mtrl.emissiveMap.dispose()
        if (mtrl.gradientMap)       mtrl.gradientMap.dispose()
        if (mtrl.metalnessMap)      mtrl.metalnessMap.dispose()
        if (mtrl.roughnessMap)      mtrl.roughnessMap.dispose()
        mtrl.dispose()    // disposes any programs associated with the material
      }

      if (node instanceof THREE.Mesh) {
        if (node.geometry) node.geometry.dispose()
        if (node.material) {
          if (node.material && node.material.materials) {  
          // if (node.material instanceof THREE.MeshFaceMaterial) {            
            node.material.materials.map(mtrl => {
              clearMaterial(mtrl)
            })
          } else {
            if (Array.isArray(node.material)) {
              node.material.map(mtrl => {
                clearMaterial(mtrl)
              })
            } else {
              clearMaterial(node.material)
            }
          }
        }
      }
    },
    vrmDeepDispose (vrm) {
      VRMUtils.deepDispose(vrm.scene)
    },
    disposeScene ({ renderer, scene }) {
      // console.log('disposeScene')
      scene.traverse(node => {
        if (node.userData.vrm) this.vrmDeepDispose(node.userData.vrm)
        this.disposeNode(node)
      })

      for (let i=scene.children.length - 1; i >= 0; i--) { 
        scene.remove(scene.children[i])
      }
      
      renderer.renderLists.dispose()
      renderer.dispose()
      
      if (this.composer.passes) {
        this.composer.passes.map(pass => {
          if (pass.dispose) {
            pass.dispose()
            if (pass.depthTarget) {
              pass.depthTarget.dispose()
            }
            if (pass.fsQuad) {
              pass.fsQuad.material.dispose()
              pass.fsQuad._mesh.traverse(node => {
                this.disposeNode(node)
              })
              pass.fsQuad.dispose()
            }
            if (pass.normalOverrideMaterial){
              pass.normalOverrideMaterial.dispose()
            }
          }
        })
      }
      
      if (this.webGLRendererTarget) this.webGLRendererTarget.dispose()
    },
    // for params
    toPosition (vector) {
      return { x: vector.x, y: vector.y, z: vector.z }
    },
    toVector3 (vec) {
      return new THREE.Vector3(vec.x, vec.y, vec.z)
    },
    toEuler3XYZ (euler) {
      return new THREE.Euler(euler.x, euler.y, euler.z, 'XYZ')
    },
    toObjColor (color) {
      return { r: color.r, g: color.g, b: color.b }
    },
    toColor3 (color) {
      return new THREE.Color(color.x, color.y, color.z)
    },
    toRotation (rotation) {
      return { x: rotation.x, y: rotation.y, z: rotation.z }
    },
    toScale (scale) {
      return { x: scale.x, y: scale.y, z: scale.z }
    }
  }
}